module.exports = __webpack_public_path__ + "img/short.c221af14.png";